import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import { getRoleBasedRedirect, isTokenExpired } from "../utils/HelperMethod";
import { useUserLogout } from "../custom-hooks/queries";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();

  const token = useAuthStore((s) => s.token);
  const role = useAuthStore((s) => s.role);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  const logoutMutation = useUserLogout();

  // 🔥 Token expiry check
  useEffect(() => {
    if (token && isTokenExpired(token)) {
      logoutMutation.mutate(null, {
        onSettled: () => {
          logout(); // 👈 zustand clear
          navigate("/signin");
        },
      });
    }
  }, [token]);

  // ❌ Not authenticated
  if (!token) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // 🔐 Role check
  const normalizedUserRole = role?.toLowerCase();
  const normalizedAllowedRoles = allowedRoles.map((r) => r.toLowerCase());

  if (
    allowedRoles.length > 0 &&
    !normalizedAllowedRoles.includes(normalizedUserRole)
  ) {
    return <Navigate to={getRoleBasedRedirect(normalizedUserRole)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
